import {IResponse, requestWithToken, requestWithTokenAxios} from "./RequestBase";
import {config} from "../config";
import {actions as actionsFile, actions, IFile, IFolder} from "../store/sliceFiles";
import {actions as modal} from "../store/sliceModal";
import {store} from "../store/configureStore";


export const fetchFiles = async (id: number | null = null): Promise<IResponse> => {
    const request = id == null ? `${config.baseurl}/api/file/` : `${config.baseurl}/api/file/${id}`
    const data: IResponse = await requestWithToken(request,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );

    if (data?.status === 200) {
        const files: IFile[] = data.data;
        store.dispatch(actionsFile.setFiles(files))
    }
    return data;
}

export const fetchFolders = async (): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/folder/`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return data;
}

export const loadFiles = async (folderId: number | undefined, file: FormData): Promise<IResponse> => {
    const request = folderId == null ? `${config.baseurl}/api/file/load` : `${config.baseurl}/api/file/load/${folderId}`
    const data: IResponse = await requestWithTokenAxios(request,
        {
            method: "POST",
            body: file
        }
    );
    if (data.status === 200) {
        fetchFiles(folderId)
    }
    return data;
}

export const fetchUploadFile = async (id: number, name?: string): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/file/upload/${id}`,
        {
            method: "GET",
        },
        true
    );
    if (data.status === 200) {
        // Create blob link to download
        uploadFile(data, name)
    }
    if (data.isError) {
        store.dispatch(modal.showError("Ошибка выгрузки файла"))
    }

    return data;
}

export const fetchUploadFiles = async (ids: number[]): Promise<IResponse> => {
    const params = ids.map((n)=> `ids=${n}`).join("&")
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/file/upload?${params}`,
        {
            method: "GET",
        },
        true
    );

    if (data?.status === 200) {
        uploadFile(data)
    }
    return data;
}

export const uploadFile = (data: IResponse, name?: string) => {
    const contentDisposition = data.headers.get('Content-Disposition')
    const url = window.URL.createObjectURL(data.data);

    const link = document.createElement('a');
    link.href = url;

    if (contentDisposition) {
        const filename = contentDisposition.split("filename=")
        link.setAttribute(
            'download',
            filename[filename.length - 1],
        );
    } else if (name) {
        link.setAttribute(
            'download',
            name
        )
    }
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    // @ts-ignore
    link.parentNode.removeChild(link);
}

export const fetchDeleteFile = async (id: number, isFolder: boolean): Promise<IResponse> => {
    const url = isFolder ? `${config.baseurl}/api/folder/delete/${id}` : `${config.baseurl}/api/file/${id}`
    const data: IResponse = await requestWithToken(url,
        {
            method: "DELETE",
        }
    );

    if (data?.status === 204) {
        store.dispatch(actions.deleteFile(id))
    } else {
        store.dispatch(modal.showError(data.data))
    }
    return data;
}

export const fetchDeleteFiles = async (ids: number[]): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/file/`,
        {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(ids)
        }
    );

    if (data?.status === 204) {
        store.dispatch(actions.deleteFiles(ids))
    } else {
        store.dispatch(modal.showError(data.data))
    }
    return data;
}

export const fetchRenameFile = async (id: number, name: String, isFolder: boolean): Promise<IResponse> => {
    const url = isFolder ? `${config.baseurl}/api/folder/rename` : `${config.baseurl}/api/file/rename`
    const data: IResponse = await requestWithToken(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({id, name})
        }
    );

    if (data?.status === 200) {
        const file: IFile = data.data;
        store.dispatch(actions.changeFile(file))
    } else {
        store.dispatch(modal.showError(data.data))
    }
    return data;
}

export const fetchMoveFile = async (currentId: number, folderId: number | null, isFolder: boolean): Promise<IResponse> => {
    const url = isFolder ? `${config.baseurl}/api/folder/move` : `${config.baseurl}/api/file/move`
    const data: IResponse = await requestWithToken(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({currentId, folderId})
        }
    );

    if (data?.status === 200) {
        const file: IFile = data.data;
        store.dispatch(actions.deleteFile(file.id))
    } else {
        store.dispatch(modal.showError(data.data))
    }
    return data;
}


export const fetchMoveFileAll = async (ids: number[], folderId: number | null): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/file/move/all`,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ids, folderId})
        }
    );

    if (data?.status === 200) {
        const files: IFile[] = data.data;
        store.dispatch(actions.deleteFiles(files.map((file: IFile) => file.id)))
    } else {
        store.dispatch(modal.showError(data.data))
    }
    return data;
}

export const fetchRotateIcon = async (id: number, rotate: number): Promise<IResponse> => {
    const url = `${config.baseurl}/api/file/rotate`
    const data: IResponse = await requestWithToken(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({id, rotate})
        }
    );

    if (data?.status === 200) {
        const file: IFile = data.data;
        store.dispatch(actions.changeIconFile(file))
    } else {
        store.dispatch(modal.showError(data.data))
    }
    return data;
}

export const fetchCreateFolder = async (parentId: number | null | undefined, name: String): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.baseurl}/api/folder/create`,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({parentId, name})
        }
    );

    if (data?.status === 200) {
        const file: IFile = data.data;
        store.dispatch(actions.addFile(file))
    } else {
        store.dispatch(modal.showError(data.data))
    }
    return data;
}


